import React from 'react'
import { arrayOf, string } from 'prop-types'

/**
 * Renders Page Builder CSS as real <style> elements (not via innerHTML on a div).
 */
const PageBuilderStyleTags = ({ cssBlocks = [], idPrefix = 'pb' }) => {
    if (!cssBlocks.length) {
        return null
    }

    return cssBlocks.map((css, index) => (
        <style
            key={`${idPrefix}-${index}`}
            data-pb-style-block={idPrefix}
            dangerouslySetInnerHTML={{ __html: css }}
        />
    ))
}

PageBuilderStyleTags.propTypes = {
    cssBlocks: arrayOf(string),
    idPrefix: string
}

export default PageBuilderStyleTags
